<template>
  <div style="margin-top:10px">
    <el-alert
      title="温馨提示"
      type="info"
      show-icon
      style="margin-bottom: 15px;"
    >
      <ul style="margin: 0; padding-left: 20px;">
        <li>1. 默认展示近3个月的数据</li>
        <li>2. 单卡可查所有数据</li>
        <li>3. 其余条件只能查询3个自然月以内的数据</li>
      </ul>
    </el-alert>
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          placeholder="公司名"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="operationName" >
        <el-select v-model="queryParams.operationName" filterable multiple placeholder="运营商" @change="search" clearable>
          <el-option v-for="item in operationNames" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          ref="datePicker"
          v-model="dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
           @change="handleDateChange"
           @clear="handleDateClear">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download" v-hasPermi="['card:flow:day:export']" @click="exportFlow">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="operationName" label="运营商" align="center" min-width="220" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="dayTime" label="时间" align="center" min-width="180" >
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.dayTime,'{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="dayFlow" label="日流量（M）" align="center" min-width="100" ></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { cardFlowDay } from "@/api/api.js";
import { agentTreeList } from "@/api/api.js"; //代理商
import { exportFlowDay } from "@/api/api.js"; //代理商
export default {
  data() {
    return{
      queryParams:{
          iccid:undefined,
          operationName:undefined
      },
      // 代理商
      agentTree: [],
      tableData:[],
      operationNames:[
        {
          value: "中国电信",
          label: "中国电信"
        },
        {
          value: "中国移动",
          label: "中国移动"
        },
        {
          value: "中国联通",
          label: "中国联通"
        },
      ],
      page: 1,
      pageSize: 20,
      total:0,
      dateRange:[],
      pickerOptions: {},
    }
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    //代理商列表
    agentTreeListMethod(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 初始化数据
    initData(){
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      cardFlowDay(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total
      })
    },
    search(){
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    exportFlow(){
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange),
      };
      this.$alert("确定导出历史流量吗？", "历史流量导出", {
        confirmButtonText: "确定"
      }).then(() => {
        exportFlowDay(params).then(res => {
          this.$notify({
              title: "成功",
              message: "历史流量导出成功，请在任务中心查看",
              type: "success",
              offset:30
            });
        });
      });
    },
    // 详情跳转
    infoRow(row){
      this.$router.push('/order/invoiceDetail/' + row.id);
    },
    // 监听pick事件，实时获取选择过程中的日期
    handleDateChange(newVal) {
      if (!newVal || newVal.length !== 2) return;

      const startDate = new Date(newVal[0]);
      const endDate = new Date(newVal[1]);
      
      // 精确计算月份差（支持跨年份）
      const monthDiff = (endDate.getFullYear() - startDate.getFullYear()) * 12 
                      + (endDate.getMonth() - startDate.getMonth());

      if (monthDiff > 3) {
        this.$message.warning('查询区间不能超过3个自然月，已自动调整为最近3个月');
        // 自动重置为最近3个月
        const newEnd = new Date();
        const newStart = new Date();
        newStart.setMonth(newStart.getMonth() - 3);
        this.dateRange = [this.formatDate(newStart), this.formatDate(newEnd)];
      }
    },
    handleDateClear() {
      this.dateRange = [];
    },
    initDate(){
      const end = new Date();
      const start = new Date();
      start.setMonth(start.getMonth() - 3);
      this.dateRange = [this.formatDate(start), this.formatDate(end)];
      const that = this; 
      this.pickerOptions = {
        shortcuts: [{
          text: '最近一周',
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 3);
            picker.$emit('pick', [start, end]);
          }
        }],

        disabledDate: (date) => {
          // 统一时间基准：所有日期都按0点0分0秒比较
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const currentDate = new Date(date);
          currentDate.setHours(0, 0, 0, 0);

          // 规则1：永远禁用今天之后的所有日期（只查历史数据）
          if (currentDate > today) return true;

          // 获取DatePicker内部实时状态（无需等待任何事件）
          if (!that.$refs) return false;
          if (!that.$refs.datePicker) return false;
          if (!that.$refs.datePicker.picker) return false;

          const pickerInstance = that.$refs.datePicker.picker;
          // selection：当前已选择的日期数组
          // - 未选择：[]
          // - 选了第一个日期：[Date]
          // - 选完两个日期：[Date, Date]
          const selection = pickerInstance.value || [];

          // 情况1：未选择任何日期 → 只能选最近3个月内的日期
          if (selection.length === 0) {
            const threeMonthsAgo = new Date(today);
            threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
            return currentDate < threeMonthsAgo;
          }

          // 情况2：已选一个日期 → 根据当前显示的面板判断用户在选什么
          if (selection.length === 1) {
            const selectedDate = new Date(selection[0]);
            selectedDate.setHours(0, 0, 0, 0);

            // showPanel判断：'left'=正在选开始日期 'right'=正在选结束日期
            const isSelectingEndDate = pickerInstance.showPanel === 'right';

            if (isSelectingEndDate) {
              // ✅ 先选了开始日期，现在选结束日期
              // 结束日期范围：[开始日期, 开始日期+3个月]
              const maxEndDate = new Date(selectedDate);
              maxEndDate.setMonth(maxEndDate.getMonth() + 3);
              return currentDate < selectedDate || currentDate > maxEndDate;
            } else {
              // ✅ 先选了结束日期，现在选开始日期
              // 开始日期范围：[结束日期-3个月, 结束日期]
              const minStartDate = new Date(selectedDate);
              minStartDate.setMonth(minStartDate.getMonth() - 3);
              return currentDate > selectedDate || currentDate < minStartDate;
            }
          }

          // 情况3：已选完两个日期 → 不限制（允许重新选择）
          return false;
        }
      };
    }
  },
  created() {
    this.initDate();
    this.search();
    this.agentTreeListMethod();
  },
  mounted() {

  },

};
</script>


